/**************************************************
 * Nombre:       Tarjetas_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../Utilidades/formatoMoneda";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Producto = ({item}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2}}
        >

            <Grid container size={4}>
                <img src={item.img} width={'90%'}/>
            </Grid>

            <Grid container size={{xs: 8, sm: 8, md: 8}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{fontWeight: 400, fontSize: 12, color: '#00000080'}}>{item.coleccion}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12
                            }}>{`Talla/Tipo: ${item.varianteNombre}`}</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-end'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 4}}>
                                <Typography sx={{fontWeight: 600, fontSize: 16, color: '#00000080'}}>
                                    {`Cantidad: ${item.cantidad}`}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 8}}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{fontWeight: 600, fontSize: 12, color: '#00000080'}}>
                                            {`Valor Antes ${formatoMonedaTabla(item.valorAntes)}`}
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                        }}>{formatoMoneda(item.cantidad * item.valor)}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto    